import { createDeviceOrder } from '@/ducks/deviceOrdersReducer'
import { post, get } from '@/util/auth'

import {
  API_ROUTE_DEVICE_ORDER,
  API_ROUTE_DEVICE_ORDER_CANCEL,
  API_ROUTE_DEVICE_ORDER_COMPLETE,
  API_ROUTE_DEVICE_ORDER_DELIVER,
  API_ROUTE_DEVICE_ORDER_SMS,
  API_ROUTE_DEVICE_ORDERS,
  API_ROUTE_DEVICE_ORDER_ECOM,
} from './apiRoutes'

export const getDeviceOrdersAPI = async () => {
  const response = await get(API_ROUTE_DEVICE_ORDERS)

  return transformOrdersFromWS(response)
}

const transformOrdersFromWS = (orders: any) =>
  orders.map((order: any) =>
    createDeviceOrder({
      activationNumber: order.activation_number,
      ...order,
    })
  )

export const getDeviceOrderAPI = (orderId: number) =>
  get(API_ROUTE_DEVICE_ORDER.replace(':order_id', String(orderId)))

export const postDeviceOrderAPI = ({ orderId, order }: { orderId: number; order: any }) =>
  post(API_ROUTE_DEVICE_ORDER.replace(':order_id', String(orderId)), order)

export const cancelDeviceOrderAPI = ({ orderId, order }: { orderId: number; order: any }) =>
  post(API_ROUTE_DEVICE_ORDER_CANCEL.replace(':order_id', String(orderId)), order)

export const completeDeviceOrderAPI = ({ orderId, order }: { orderId: number; order: any }) =>
  post(API_ROUTE_DEVICE_ORDER_COMPLETE.replace(':order_id', String(orderId)), order)

export const deliverDeviceOrderAPI = ({ orderId, order }: { orderId: number; order: any }) =>
  post(API_ROUTE_DEVICE_ORDER_DELIVER.replace(':order_id', String(orderId)), order)

export const sendDeviceOrderToEcomAPI = async (orderId: number) =>
  post(API_ROUTE_DEVICE_ORDER_ECOM.replace(':order_id', String(orderId)))

export const sendDeviceOrderSmsAPI = ({
  orderId,
  aliasId,
  message,
}: {
  orderId: number
  aliasId: number
  message: any
}) =>
  post(API_ROUTE_DEVICE_ORDER_SMS.replace(':order_id', String(orderId)), {
    aliasId,
    message,
  })
